var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({domProps:{"innerHTML":_vm._s(_vm.svg.content)}},'svg',_vm.svg.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }